'use strict';

/**
 * Allow only lowercase input
 * From: http://stackoverflow.com/questions/16388562/angularjs-force-uppercase-in-textbox
 */
angular.module('mobile-apps')
	.directive('lowercaseInput', function() {
		return {
			require: 'ngModel',
			link: function(scope, element, attrs, modelCtrl) {
				modelCtrl.$parsers.push(function(input) {
					return input ? input.toLowerCase() : "";
				});
				element.css("text-transform","lowercase");
			}
		};
	});
